import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatHint, MatSuffix } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
  MatDatepickerActions,
  MatDatepickerCancel,
  MatDatepickerApply,
} from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-remove-all-hours-exceptions',
  templateUrl: './remove-all-hours-exceptions.component.html',
  styleUrls: ['./remove-all-hours-exceptions.component.scss'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  imports: [
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatHint,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDatepickerActions,
    MatButton,
    MatDatepickerCancel,
    MatDatepickerApply,
    MatCheckbox,
  ],
})
export class RemoveAllHoursExceptionsComponent {
  public removeExceptionsForm: FormGroup = new FormGroup({
    date: new FormControl('', Validators.required),
    confirmation: new FormControl(false, Validators.required),
  });

  public currentFacilityId: string;

  constructor(
    public dialogRef: MatDialogRef<RemoveAllHoursExceptionsComponent>,
    private facilityManager: FacilityManager,
  ) {
    this.currentFacilityId = this.facilityManager.getCurrentFacility();
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public isIntentConfirmed(): boolean {
    return this.removeExceptionsForm.get('confirmation')?.value && this.removeExceptionsForm.get('date')?.valid;
  }

  public startOverrideRemoval(): void {
    this.dialogRef.close(this.removeExceptionsForm.get('date')?.value);
  }
}
